import { Session } from './session';

export class Agenda {
  id: number;
  description: string;
  place: string;
  startTime: string;
  openSpaceId: number;
  sessions: Session[];
  publicAgenda: boolean;
  showVotes: boolean;
  showProposer: boolean;
}
